import Setup from "../../../container/setup/index";
import BillOfMaterials from "../../../container/setup/BillOfMaterials";
import CPChecklist from "../../../container/setup/CPChecklistComponent";
import QCChecklist from "../../../container/setup/QualityChecklist";


const setupRoute = [
  {
    path: "setup",
    element: <Setup />,
  },
  {
    path: "setup/bill-of-material",
    element: <BillOfMaterials />,
  },
  {
    path: "setup/cp-checklist",
    element: <CPChecklist />,
  },
  {
    path: "setup/qc-checklist",
    element: <QCChecklist />,
  },
];

export default setupRoute;
